import React from 'react';

import {
  downloadPayrunBACSRequest,
  downloadPayrunsBACSRequest,
  getPayrunAsFileRequest,
  getPayrunRequest,
  markPayrunAsPaidForEmployeeRequest,
  markPayrunAsPaidRequest,
  refreshPayrunRequest,
  sendPayslipsByEmailRequest,
  sendPayslipsBySMSRequest,
  sendPayslipsToEmployeesByEmailRequest,
  sendPayslipsToEmployeesBySMSRequest,
} from '@vyce/core/src/api/pay';
import { sendPassportRequest, sendShareCodeRequest } from '@vyce/core/src/api/notifications';
import { Payrun } from '@vyce/core/src/views/payroll/Payrun';

import { useTypedSelector } from '../../hooks';

export const PayrunPage: React.FC = () => {
  const { access_token } = useTypedSelector(state => state.helper);

  return (
    <Payrun
      sendPayslipsToEmployeesBySMSRequest={sendPayslipsToEmployeesBySMSRequest}
      sendPayslipsToEmployeesByEmailRequest={sendPayslipsToEmployeesByEmailRequest}
      token={access_token}
      sendPassportRequest={sendPassportRequest}
      sendShareCodeRequest={sendShareCodeRequest}
      sendPayslipsBySMSRequest={sendPayslipsBySMSRequest}
      sendPayslipsByEmailRequest={sendPayslipsByEmailRequest}
      getPayrunAsFileRequest={getPayrunAsFileRequest}
      getPayrunRequest={getPayrunRequest}
      markPayrunAsPaidForEmployeeRequest={markPayrunAsPaidForEmployeeRequest}
      downloadPayrunBACSRequest={downloadPayrunBACSRequest}
      downloadPayrunsBACSRequest={downloadPayrunsBACSRequest}
      refreshPayrunRequest={refreshPayrunRequest}
      markPayrunAsPaidRequest={markPayrunAsPaidRequest}
    />
  );
};
